(function () {

  function checkCountryAvailability() {

    fetch('/browsing_context_suggestions.json')
      .then(response => response.json())
      .then(data => {

        const country = data.detected_values.country.handle;

        console.log("País real detectado:", country);

        if (country !== "US") {

          document.querySelectorAll('button[name="add"]').forEach(function(button){

            button.innerText = "No disponible";
            button.disabled = true;
            button.style.pointerEvents = "none";

          });

        }

      });

  }


  document.addEventListener("DOMContentLoaded", function(){
    checkCountryAvailability();
  });


})();